import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  Renderer2,
  SimpleChanges,
  ViewChild,
  forwardRef,
  inject
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { picklist } from 'src/app/STORE/selectors/propertypane.selector';
import { ApiConstants } from 'src/app/base/api-constants';
import { HttpBaseService } from 'src/app/base/http-base.service';
import { pageTableType } from 'src/app/pages/prototyping/screens/screens.component';
import { AppGlobalService } from 'src/app/services/app.global.service';
@Component({
  selector: 'vb-filter-options',
  templateUrl: './filter-options.component.html',
  styleUrls: ['./filter-options.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FilterOptionsComponent),
      multi: true
    }
  ],
  standalone: false  //NOSONAR
})
export class FilterOptionsComponent implements OnInit {
  private renderer = inject(Renderer2);
  private elementRef = inject(ElementRef);
  private store = inject(Store);
  private baseService = inject(HttpBaseService);

  @Input() formData;
  @Input() element;
  @Input() disableField;
  @Input() formGroup;
  @Input() currentScreen;
  fieldType: any;
  showDropdown = false;
  selectedOption: any;
  filterOptions: any[] = [];
  subscriptions: Subscription[] = [];
  private modelValue: any;
  private onChange: (m: any) => void;
  private onTouched: (m: any) => void;
  pickList: any;

  ngOnInit(): void {
    console.log(this.formData);
    this.fieldType = null;
    const dataSub = this.store.select(picklist).subscribe((picklist) => {
      if (picklist) {
        this.pickList = picklist;
        this.fieldType = this.pickList.fieldsWithType
          .filter((fld) => this.formData.currentNode == fld.sid || this.formData.data == fld.name)[0]
          ?.type?.toLowerCase();
        if (this.formData.fkTablesid && !this.fieldType) {
          const tableId: any = this.formData.fkTablesid;
          const parts = this.formData.currentNode.split('_');

          this.baseService.get(ApiConstants.getFieldInfo, { tableId }).subscribe((data: any) => {
            this.fieldType = data
              .filter((fld) => parts[1] == fld.sid || this.formData.data == fld.name)[0]
              ?.f_type?.toLowerCase();
            this.loadFilterOptions();
          });
        } else {
          this.loadFilterOptions();
        }
      }
    });
    this.subscriptions.push(dataSub);
  }

  setDisabledState(isDisabled: boolean) {
    this.renderer.setProperty(this.elementRef.nativeElement, 'disabled', isDisabled);
    this.disableField = isDisabled;
  }

  loadFilterOptions() {
    this.showDropdown = true;
    switch (this.fieldType) {
      case 'string':
        this.filterOptions = [
          {
            name: 'String',
            value: 'string'
          }
        ];
        break;
      case 'dropdown':
      case 'radio':
        this.filterOptions = [
          {
            name: 'Single dropdown',
            value: 'single dropdown'
          },
          {
            name: 'Radio button',
            value: 'radio'
          }
        ];
        if (!this.formData.mandatory) {
          this.filterOptions = [
            ...this.filterOptions,
            {
              name: 'Multi select dropdown',
              value: 'multi select dropdown'
            }
          ];
        }
        break;
      case 'date':
        this.filterOptions = [
          {
            name: 'Date',
            value: 'date'
          }
        ];
        if (!this.formData.mandatory) {
          this.filterOptions = [
            ...this.filterOptions,
            {
              name: 'Date Range',
              value: 'daterange'
            }
          ];
        }
        break;
      case 'datetime':
        this.filterOptions = [
          {
            name: 'Date Time Range',
            value: 'datetimerange'
          }
        ];
        break;
      case 'number':
      case 'auto-number':
        this.filterOptions = [
          {
            name: 'Number',
            value: 'number'
          }
        ];
        if (!this.formData.mandatory) {
          this.filterOptions = [
            ...this.filterOptions,
            {
              name: 'Number range',
              value: 'number range'
            }
          ];
        }
        break;
      case 'double':
        this.filterOptions = [
          {
            name: 'Double',
            value: 'double'
          }
        ];
        if (!this.formData.mandatory) {
          this.filterOptions = [
            ...this.filterOptions,
            {
              name: 'Double range',
              value: 'double range'
            }
          ];
        }
        break;
      case 'currency':
        this.filterOptions = [
          {
            name: 'Currency',
            value: 'currency'
          }
        ];
        if (!this.formData.mandatory) {
          this.filterOptions = [
            ...this.filterOptions,
            {
              name: 'Currency range',
              value: 'currency range'
            }
          ];
        }
        break;
      default:
        this.filterOptions = [];
        this.showDropdown = false;
        break;
    }
    if (this.currentScreen?.pageTableType === pageTableType.QUERY_VIEW) {
      this.disableField = true;
      if (this.fieldType === 'datetime') {
        this.filterOptions = [
          {
            name: 'Date Time',
            value: 'datetime'
          }
        ];
      }
    }
  }

  writeValue(value: any): void {
    this.setSelectedValue(value);
    this.modelValue = value;
  }

  handleChange(event: any) {
    this.modelValue = event.value;
    this.onChange(this.modelValue);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setSelectedValue(value) {
    if (value) {
      this.selectedOption = value;
    }
  }
}
